import { Observable } from 'rxjs';

import { MgmtDept, MgmtDeptRestriction } from '../models/mgmt-dept.model';

export abstract class MgmtDeptGateway {
  abstract getMgmtDept(mgmtDeptId: string): Observable<MgmtDept>;
  abstract updateMgmtDeptRestriction(mgmtDeptId: string, restriction: MgmtDeptRestriction): Observable<MgmtDept>;
}
